import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { StorageService } from './storage.service';
import { User } from '../models/user.model';
import { OktaService } from './okta.service';

@Injectable()
export class SessionService {

    private userDetails: User;
    private userDetailsObserver = new Subject<User>();
    public userDetails$ = this.userDetailsObserver.asObservable();
    private states: any = {};
    private saharaVersion: string;
    

    constructor(private storageService: StorageService, private oktaService: OktaService) {
        this.setUserDetailsFromStorage();
    }

    getUserDetails() {
        return this.userDetails;
    }

    setUserDetails(userDetails: any) {
        return this.userDetails = userDetails;
    }

    setUserDetailsFromStorage() {
        const oktaTokenStorage = this.storageService.get('okta-token-storage');
        const accessToken = oktaTokenStorage && oktaTokenStorage['accessToken'];
        const claims = accessToken && accessToken['claims'];
        if (claims) {
            this.userDetails = new User();
            this.userDetails.id = claims.uid;
            this.userDetails.domain = claims.mkpDomain;
            this.userDetails.username = claims.mkpEmail;
            this.userDetails.token = accessToken['accessToken'];
            this.userDetails.groups = claims.mkpGroups;
        }
    }

    getUserDomain(): String {
        return this.userDetails['domain'];
    }

    getUserGroups() {
        return this.userDetails['groups'];
    }

    hasUserGroup(group: string) {
        return this.getUserGroups() ? (this.getUserGroups().indexOf(group) > -1) : false;
    }

    clearUserDetails() {
        this.storageService.delete('hidden_alerts');
        this.storageService.delete('user');
    }

    getToken() {
        const oktaTokenStorage = this.storageService.get('okta-token-storage');
        const accessToken = oktaTokenStorage && oktaTokenStorage['accessToken'];
        return accessToken && accessToken['accessToken']
    }

    get(key: string): any {
        return this.states[key] ? this.states[key] : null;
    }

    set(key: string, value: any) {
        this.states[key] = value;
        return this.states[key];
    }

    remove(key: string): any {
        delete this.states[key];
    }

    getSaharaVersion(): string {
        return this.saharaVersion;
    }

    setSaharaVersion(key: string) {
        this.saharaVersion = key;
        return this.saharaVersion;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/session.service.ts